import { render, staticRenderFns } from "./RevaluationQuotas.vue?vue&type=template&id=2d795f3b&scoped=true"
import script from "./RevaluationQuotas.vue?vue&type=script&lang=ts"
export * from "./RevaluationQuotas.vue?vue&type=script&lang=ts"
import style0 from "./RevaluationQuotas.vue?vue&type=style&index=0&id=2d795f3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d795f3b",
  null
  
)

export default component.exports